import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { ReviewCarousel } from './ReviewCarousel';
import { ButtonLink } from '../ButtonLink';
import { PrincipleList } from '../PrincipleList';
import { Reveal } from '../Reveal';
import { reviews } from '../../data/reviews';
import { employerCommitments } from '../../data/employers';
import { getPublishedReviews } from '../../utils/reviews';
interface TrustedByLeadersProps {
  /** Drop the section heading when the page already introduces it. */
  embedded?: boolean;
  shareHref?: string;
}
export function TrustedByLeaders({
  embedded = false,
  shareHref = '/reviews#share'
}: TrustedByLeadersProps) {
  const published = getPublishedReviews(reviews, 5);
  const hasReviews = published.length > 0;
  return <section className="overflow-hidden bg-midnight-950 text-champagne-50" aria-labelledby={embedded ? undefined : 'trusted-heading'} aria-label={embedded ? 'Client reviews' : undefined} data-id="element-301" data-mp="36p0e1h6bppy">
      <div className={`mx-auto max-w-site px-6 pb-20 lg:px-10 lg:pb-28 ${embedded ? 'pt-2' : 'pt-20 lg:pt-28'}`} data-id="element-302" data-mp="3gmggb54xvfqr">
        {!embedded && <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between" data-id="element-303" data-mp="3lk9o22lw4ht5">
            <div className="max-w-xl" data-id="element-304" data-mp="3qffixqx9t6td">
              <h2 id="trusted-heading" className="font-serif text-3xl md:text-4xl lg:text-5xl" data-id="element-305" data-mp="3uffwl9cjpdzd">
                Trusted by Leaders
              </h2>
              <p className="mt-4 text-[15px] leading-relaxed text-champagne-100/70 md:text-[17px]" data-id="element-306" data-mp="2xqi0nnt27a0m">
                Selected feedback from leaders and organisations who have experienced the Qorvessa approach.
              </p>
            </div>
            {hasReviews && <Link to={shareHref} className="inline-flex shrink-0 items-center gap-2 text-sm font-medium text-champagne-200 underline decoration-champagne-300/40 underline-offset-[6px] hover:text-champagne-50" data-id="element-307" data-mp="3bp803a3cpls5">
                Share your experience
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-308" data-mp="2n1c6654xgueo" />
              </Link>}
          </div>}

        {hasReviews ? <div className={embedded ? '' : 'mt-10 lg:mt-12'} data-id="element-309" data-mp="2iz7gfhhlohxb">
            <ReviewCarousel reviews={published} data-id="element-310" data-mp="2x01r66s4euz5" />
          </div> : <>
            <Reveal className={embedded ? '' : 'mt-10 lg:mt-12'} data-id="element-311" data-mp="2rzx9weje1w7v">
              <div className="flex flex-col gap-6 rounded-lg border border-champagne-100/10 bg-midnight-900 p-6 sm:p-8 md:flex-row md:items-center md:justify-between lg:p-10" data-id="element-312" data-mp="2ryci2wogkrdp">
                <div className="max-w-2xl" data-id="element-313" data-mp="1zdck3iik9s6f">
                  <h3 className="text-sm font-medium text-champagne-300" data-id="element-314" data-mp="2e0e2xp2bcqx5">Client feedback coming soon</h3>
                  <p className="mt-3 font-serif text-2xl leading-snug text-champagne-50 md:text-3xl" data-id="element-315" data-mp="29a7crks5kycs">
                    We publish reviews only from verified clients and candidates, with their permission.
                  </p>
                </div>
                <ButtonLink to={shareHref} variant="outlineDark" withArrow className="self-start md:self-auto" data-id="element-316" data-mp="1gl06fzmgj4gz">
                  Share your experience
                </ButtonLink>
              </div>
            </Reveal>

            <div className="mt-16 grid gap-8 lg:mt-20 lg:grid-cols-12 lg:gap-10" data-id="element-317" data-mp="vsl4rcrva1a">
              <div className="lg:col-span-4" data-id="element-318" data-mp="3j9s17h5ftfk1">
                <h3 className="font-serif text-2xl md:text-3xl" data-id="element-319" data-mp="3n90wiqg4llhp">The Qorvessa Approach</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-champagne-100/70 md:text-base" data-id="element-320" data-mp="etyzio24ahak">What clients can expect from every engagement.</p>
              </div>
              <div className="lg:col-span-8" data-id="element-321" data-mp="jqpo5zrzml7l">
                <PrincipleList items={employerCommitments} tone="dark" data-id="element-322" data-mp="5tu3fa2dj5bp" />
              </div>
            </div>
          </>}
      </div>
    </section>;
}